import { render } from "./PlatformSettings.vue?vue&type=template&id=9c233174&scoped=true"
import script from "./PlatformSettings.vue?vue&type=script&lang=js"
export * from "./PlatformSettings.vue?vue&type=script&lang=js"

import "./PlatformSettings.vue?vue&type=style&index=0&id=9c233174&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c233174"]])

export default __exports__